module.exports = __webpack_public_path__ + "img/y4pt.6f686df3.png";